<div class="tab-source">
  <ul class="tabs" [class.hidden]="!filterShow && common.isMobileMode">
    <li
      *ngFor="let r of formSettingResources"
      class="tab-link resource-item px-2"
      [class.active]="r.SystemName === activeSystemName"
      (click)="onClick(r.SystemName); filterShow = !filterShow">
      <i class="{{ r.icon }} align-self-center seticon"></i><span class="title">{{ r.Title }}</span>
    </li>
  </ul>
</div>
